import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

import {GET_ACTIVITY_LOG, GET_ACTIVITY_LOG_EXPORT_DATA} from '../actiontypes';

export const getActivityLog = (projectId, entities, tableConfig = {}) => {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}/ActivityFeedInquiry`;
	const payload = {
		entities,
		...tableConfig
	};
	return {
		type: GET_ACTIVITY_LOG,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		},
		payload
	};
};

export const getActivityLogExportData = (projectId, entities) => {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}/ActivityFeedInquiry`;
	const payload = {
		entities,
		page: 1,
		pageSize: 99999,
		orderBy: 'activityDate',
		orderByAscending: false
	};
	return {
		type: GET_ACTIVITY_LOG_EXPORT_DATA,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		},
		payload
	};
};
